module.exports = __webpack_public_path__ + "img/feature1.b20e19ce.png";